module.exports = __webpack_public_path__ + "static/media/dashboard.b0bafae1.svg";